import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "entity" }
const _hoisted_2 = {
  key: 0,
  class: "tracker-link"
}
const _hoisted_3 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TableHead = _resolveComponent("TableHead")
  const _component_Image = _resolveComponent("Image")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Column = _resolveComponent("Column")
  const _component_ExternalLink = _resolveComponent("ExternalLink")
  const _component_Icon = _resolveComponent("Icon")
  const _component_TrackerBase = _resolveComponent("TrackerBase")

  return (_openBlock(), _createBlock(_component_TrackerBase, { widget: $props.widget }, {
    default: _withCtx(() => [
      _createVNode(_component_Column, { field: "entity.name" }, {
        header: _withCtx(() => [
          _createVNode(_component_TableHead, { name: "Company" })
        ]),
        body: _withCtx(({data: {entity}}) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Image, {
              src: entity.image_url,
              placeholder: "assets/company-placeholder.png",
              size: "3rem"
            }, null, 8 /* PROPS */, ["src"]),
            _createVNode(_component_Ellipsis, { class: "entity-name" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(entity.name), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Column, { field: "entity.industries" }, {
        header: _withCtx(() => [
          _createVNode(_component_TableHead, { name: "Industry / Sector" })
        ]),
        body: _withCtx(({data: {entity}}) => [
          _createVNode(_component_Ellipsis, { class: "secondary" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString((entity.industries || []).join(', ') || '—'), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Column, { field: "entity.linkedin_url" }, {
        header: _withCtx(() => [
          _createVNode(_component_TableHead, { name: "LinkedIn URL" })
        ]),
        body: _withCtx(({data: {entity}}) => [
          ($options.linkedin(entity))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_ExternalLink, {
                  href: $options.linkedin(entity)
                }, null, 8 /* PROPS */, ["href"]),
                _createVNode(_component_Icon, {
                  class: "link-icon",
                  icon: "external-link",
                  size: "1.4rem",
                  stroke: "var(--brand-200)"
                })
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, "—"))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["widget"]))
}